import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import instagramIcon from "../assets/images/instagram_blue.svg";
import "./PrivacyPolicy.css";

function CcPolicy() {
  useEffect(() => {
    const originalTitle = document.title;
    document.title =
      "Cyber-Crime, Child Protection, Non-Consensual Activity & Human Trafficking Policy - TLINK.ME";
    window.scrollTo(0, 0);

    return () => {
      document.title = originalTitle;
    };
  }, []);

  return (
    <div className="privacy-container">
      <header className="privacy-header">
        <div className="header-content">
          <div className="header-logo">
            <Link to="/" className="logo-link">
              <h1>TLINK.ME</h1>
            </Link>
          </div>
        </div>
      </header>

      <main className="privacy-content">
        <h1 className="privacy-title">
          Cyber-Crime, Child Protection, Non-Consensual Activity &amp; Human
          Trafficking Policy
        </h1>

        <h2 className="privacy-h2">1. Purpose &amp; Commitment</h2>
        <p className="privacy-text">
          TLINK maintains a zero-tolerance policy toward cyber-crime, child
          sexual exploitation, non-consensual activity, and human trafficking.
          The company is committed to preventing, detecting, and responding to
          any activity that may involve illegal, abusive, or exploitative
          conduct on or in connection with its platform.
        </p>

        <h2 className="privacy-h2">2. Scope</h2>
        <p className="privacy-text">
          This policy applies to all platform users, creators, content,
          communications, and activities conducted through TLINK’s services,
          including interactions facilitated via Telegram.
        </p>

        <h2 className="privacy-h2">3. Cyber-Crime Prevention</h2>
        <p className="privacy-text">
          TLINK maintains measures designed to prevent and detect cyber-crime,
          including but not limited to:
        </p>
        <ul>
          <li>Fraud, impersonation, or identity misuse</li>
          <li>Unauthorized access or account compromise</li>
          <li>Abuse of automated systems or bots</li>
          <li>Financial scams or deceptive practices</li>
        </ul>

        <p className="privacy-text">Controls include:</p>
        <ul>
          <li>Secure system access controls</li>
          <li>Activity monitoring and anomaly detection</li>
          <li>Integration with Telegram’s security framework</li>
          <li>Investigation and suspension of suspicious accounts</li>
        </ul>

        <p className="privacy-text">
          Confirmed cyber-crime activity results in immediate account restriction
          or termination and escalation where legally required.
        </p>

        <h2 className="privacy-h2">
          4. Child Sexual Abuse Material (CSAM) &amp; Child Protection
        </h2>
        <p className="privacy-text">
          TLINK strictly prohibits any content or activity involving minors,
          including:
        </p>
        <ul>
          <li>Child sexual abuse material (CSAM)</li>
          <li>Sexualized depictions of minors</li>
          <li>Any content that exploits, endangers, or harms a minor</li>
        </ul>

        <p className="privacy-text">Safeguards include:</p>
        <ul>
          <li>Mandatory age verification for creators</li>
          <li>Automated and manual content monitoring</li>
          <li>Immediate account termination upon detection</li>
          <li>Mandatory reporting to relevant authorities where required by law</li>
        </ul>

        <p className="privacy-text">
          TLINK cooperates fully with Telegram and law enforcement agencies in
          relation to any CSAM investigations.
        </p>

        <h2 className="privacy-h2">5. Non-Consensual Activity</h2>
        <p className="privacy-text">
          TLINK prohibits any form of non-consensual content or behavior,
          including:
        </p>
        <ul>
          <li>Content created, shared, or distributed without consent</li>
          <li>Impersonation or misuse of another individual’s likeness</li>
          <li>Blackmail, coercion, or harassment</li>
        </ul>

        <p className="privacy-text">
          Reports of non-consensual activity are treated as high priority and
          may result in:
        </p>
        <ul>
          <li>Immediate content removal</li>
          <li>Account suspension or termination</li>
          <li>Escalation to platform partners or authorities when appropriate</li>
        </ul>

        <h2 className="privacy-h2">6. Human Trafficking &amp; Exploitation</h2>
        <p className="privacy-text">
          TLINK maintains a zero-tolerance stance toward human trafficking,
          exploitation, or coercion. The platform strictly prohibits:
        </p>
        <ul>
          <li>Content or activity involving forced labor or sexual exploitation</li>
          <li>Coercion, control, or financial exploitation of individuals</li>
          <li>
            Third-party management or operation of accounts without lawful
            authority
          </li>
        </ul>

        <p className="privacy-text">
          Indicators of trafficking or exploitation are escalated for immediate
          review and, where appropriate, reported to relevant authorities.
        </p>

        <h2 className="privacy-h2">7. Monitoring &amp; Enforcement</h2>
        <p className="privacy-text">TLINK enforces this policy through:</p>
        <ul>
          <li>Automated monitoring tools</li>
          <li>Manual moderation and review</li>
          <li>Creator onboarding checks and identity verification</li>
          <li>Ongoing account and behavior monitoring</li>
        </ul>

        <p className="privacy-text">
          Violations may result in immediate enforcement action without prior
          notice.
        </p>

        <h2 className="privacy-h2">8. Reporting &amp; Cooperation</h2>
        <p className="privacy-text">TLINK:</p>
        <ul>
          <li>Maintains internal procedures for documenting and escalating violations</li>
          <li>Cooperates with Telegram, payment providers, and law enforcement</li>
          <li>Complies with all applicable mandatory reporting obligations</li>
        </ul>

        <h2 className="privacy-h2">9. Training &amp; Policy Review</h2>
        <p className="privacy-text">
          Internal staff responsible for moderation, compliance, and payouts are
          trained to recognize red flags related to cyber-crime, abuse, and
          exploitation. This policy is reviewed and updated periodically to
          reflect evolving legal, regulatory, and platform requirements.
        </p>
      </main>

      <footer className="privacy-footer">
        <div className="footer-content">
          <div className="footer-left">
            <span className="footer-title">FOLLOW US</span>
            <div className="footer-social">
              <img
                src={instagramIcon}
                alt="Instagram"
                className="footer-instagram-icon"
              />
              <a
                href="https://instagram.com/tlink.me"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-handle"
              >
                TLINK.ME
              </a>
            </div>
          </div>
          <div className="footer-center">
            <div className="footer-logo">TLINK.ME</div>
          </div>
          <div className="footer-right">
            <div className="footer-copyright">
              ALL RIGHTS RESERVED.
              <span className="footer-year">2025</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default CcPolicy;
